
<template>
  <v-autocomplete
    v-model="selectedObject"
    return-object
    v-model:search="searchText"
    :loading="loading"
    :items="lstObjects"
    item-title="name"
    item-value="id"
    hide-details
    :custom-filter="customFilter"
    label="Selecione um grupo"
    clearable
    :class="classes"
    density="compact"
  >
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template></v-autocomplete
  >
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    classes: String,
    selected: Object
  },
  data() {
    return {
      requestingApi: false,
      selectedObject: null,
      searchText: null,
      previousSearch: null,
      loading: false,
      lstObjects: [],
      timeoutSearchDelay: null,
    };
  },
  mounted() {
    var vm = this
    vm.selectedObject = vm.selected || null
  },
  activated() {},
  methods: {
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 1500);
        vm.loading = true;
      }
    },
    customFilter(item, queryText, itemText) {
      return true
    },
    submitSearch() {
      var vm = this;
      if (!vm.requestingApi) {
        let _searchText = vm.searchText;
        let _prev = (vm.previousSearch || "").toUpperCase();
        let _act = (_searchText || "").toUpperCase();
        if (_act == "" || (_act == " " && _prev == _act)) {
          vm.loading = false;
          return;
        }
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.group
            .list({
              searchText: vm.searchText
            }, 1)
            .then((result) => {
              vm.previousSearch = _searchText;
              vm.lstObjects = result?.data;
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
            });
        });
      }
    },
  },
  computed: {
    lstCustomObjects() {
      var vm = this;
      let _lst = [];
      vm.lstObjects.forEach((obj) => {
        let _name = `${obj.name} [${obj.id}]`;
        _lst.push({
          ...obj,
          name: _name,
        });
      });
      return _lst;
    },
  },
  watch: {
    selectedObject(newVal) {
      this.$emit('selected', newVal)
    },
    searchText(newVal, oldVal) {
      if (
        !oldVal ||
        newVal &&
        newVal != " " &&
        newVal.toUpperCase() != oldVal.toUpperCase()
      ) {
        this.waitAndSearch();
      }
    },
  },
};
</script>
